import { render, staticRenderFns } from "./VLayoutMiddle.vue?vue&type=template&id=7de010c2&"
import script from "./VLayoutMiddle.vue?vue&type=script&lang=js&"
export * from "./VLayoutMiddle.vue?vue&type=script&lang=js&"
import style0 from "./VLayoutMiddle.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports